import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { SwiperModule } from 'swiper/angular';

import { ContentComponent } from './content/content.component';
import { HeaderComponent } from './header/header.component';
import { NavigationOffCanvasComponent } from './navigation-off-canvas/navigation-off-canvas.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { FooterComponent } from './content/footer/footer.component';
import { NavigationMainComponent } from './header/navigation-main/navigation-main.component';
import { ToolbarCartComponent } from './header/toolbar/cart/cart.component';
import { HomeComponent } from './home/home.component';
import { MainSliderComponent } from './home/main-slider/main-slider.component';
import { ProductWidgetComponent } from './home/product-widget/product-widget.component';
import { PromoComponent } from './home/promo/promo.component';
import { SearchComponent } from './header/search/search.component';

import { ProductService } from '../my-products/shared/product.service';
import { MessageService } from '../messages/message.service';
import { CartService } from '../my-cart/shared/cart.service';
import { PagerService } from '../pager/pager.service';
import { OrderService } from '../account/orders/shared/order.service';
import { CheckoutService } from '../my-checkout/shared/checkout.service';
import { AuthService } from '../account/shared/auth.service';
import { OffcanvasService } from './shared/offcanvas.service';
import { PromoService } from './shared/promo.service';
import { UiService } from '../my-products/shared/ui.service';
import { ProductsCacheService } from '../my-products/shared/products-cache.service';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { CategoryNavComponent } from './header/category-nav/category-nav.component';
import {MyProductsModule} from '../my-products/my-products.module';
import { ToolBarComponent } from './header/tool-bar/tool-bar.component';
import { BrandsComponent } from './home/brands/brands.component';


@NgModule({
    declarations: [
        ContentComponent,
        HeaderComponent,
        NavigationOffCanvasComponent,
        TopBarComponent,
        FooterComponent,
        NavigationMainComponent,
        ToolbarCartComponent,
        HomeComponent,
        MainSliderComponent,
        ProductWidgetComponent,
        PromoComponent,
        SearchComponent,
        CategoryNavComponent,
        ToolBarComponent,
        BrandsComponent
    ],
  imports: [
    CommonModule,
    SharedModule,
    MyProductsModule,
    SwiperModule
  ],
    exports: [
        CommonModule,
        SharedModule,
        NavigationOffCanvasComponent,
        TopBarComponent,
        HeaderComponent,
        ContentComponent,
        CategoryNavComponent,
        MainSliderComponent,
        FooterComponent,
    ],
    providers: [
        ProductService,
        ProductsCacheService,
        MessageService,
        CartService,
        PagerService,
        OrderService,
        CheckoutService,
        AuthService,
        OffcanvasService,
        PromoService,
        UiService
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
